import styled from "styled-components";

import Colors from "@constants/Colors";
import { Box, Typography } from "@mui/material";

export const StyledBox = styled(Box)`
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 8px;
  padding: 4.5px 4px !important;
  min-height: 42px;
  .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${Colors.neutral_gray_300} !important;
  }
`;

export const StyledTypography = styled(Typography)<{ color: string }>`
  color: ${({ color }: { color: string }) => color};
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: 16px !important;
  line-height: 24px !important;
`;

export const StyledRootBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  padding: 8px !important;
  gap: 8px !important;
  background: ${Colors.white} !important;
  border: 1px solid ${Colors.neutral_gray_300} !important;
  border-radius: 12px !important;
`;
